export const formatPhoneNumberToConnexysFormat = (phoneNumber: string) => {
  // keep only numbers and transform to Connexys format
  let numberOnlyValue = phoneNumber.replace(/[^0-9]/g, "");

  // transform show Belgium mobile number to full: 04 xxxxxxxx should be transformed to 324xxxxxxxx
  if (numberOnlyValue.startsWith("04") && numberOnlyValue.length === 10) {
    numberOnlyValue = numberOnlyValue.replace("04", "324");
  }

  // Connexys telephone number starts with 003 and has 13 digits (example: 0032496166716)
  return numberOnlyValue.padStart(13, "0");
};
